import * as Yup from "yup";
import { productionCodes } from "../../../../utils/dataAndFormulas/productionForms";


export function initialValues(production, period, year, configForm,unitsRecorded) {
  // Función helper para obtener el coeficiente desde configForm
  const getCoefficient = (fieldName) => {
    if (configForm && configForm.fields) {
      const field = configForm.fields.find(f => f.name === fieldName);
      return field?.standardized_coefficient || 1;
    }
    return 1;
  };

  // Función helper para obtener la unidad desde configForm
  const getUnit = (fieldName) => {
    if (configForm && configForm.fields) {
      const field = configForm.fields.find(f => f.name === fieldName);
      return field?.unit || "";
    }
    return "";
  };

  let data = {
    date: production?.date || "",
    creator_user: production?.creator_user || "",
    state: production?.state || "",
    site: production?.site || "",
    period: production?.period || period,
    year: production?.year || year,
    production_volume: production?.production_volume
      ? { ...production.production_volume, unit: production.production_volume.unit || unitsRecorded?.["production_volume"] || getUnit("production_volume") }
      : { code: productionCodes["production_volume"], unit: unitsRecorded?.["production_volume"] || getUnit("production_volume"), value: "0", standardized_coefficient: getCoefficient("production_volume"), reviews: [], approvalStatus: "pending", files: [] },
    standardized_production: production?.standardized_production
      ? { ...production.standardized_production, unit: production.standardized_production.unit || unitsRecorded?.["standardized_production"] || getUnit("standardized_production") }
      : { code: productionCodes["standardized_production"], unit: unitsRecorded?.["standardized_production"] || getUnit("standardized_production"), value: "0", standardized_coefficient: 1, reviews: [], approvalStatus: "pending", files: [] },
    billing_volume: production?.billing_volume
      ? { ...production.billing_volume, unit: production.billing_volume.unit || unitsRecorded?.["billing_volume"] || getUnit("billing_volume") }
      : { code: productionCodes["billing_volume"], unit: unitsRecorded?.["billing_volume"] || getUnit("billing_volume"), value: "0", standardized_coefficient: getCoefficient("billing_volume"), reviews: [], approvalStatus: "pending", files: [] },
    standardized_billing: production?.standardized_billing
      ? { ...production.standardized_billing, unit: production.standardized_billing.unit || unitsRecorded?.["standardized_billing"] || getUnit("standardized_billing") }
      : { code: productionCodes["standardized_billing"], unit: unitsRecorded?.["standardized_billing"] || getUnit("standardized_billing"), value: "0", standardized_coefficient: 1, reviews: [], approvalStatus: "pending", files: [] },
  };

  // Asegurar que los campos estáticos tengan approvalStatus si no lo tienen
  if (data.production_volume && !data.production_volume.approvalStatus) {
    data.production_volume.approvalStatus = "pending";
  }
  if (data.standardized_production && !data.standardized_production.approvalStatus) {
    data.standardized_production.approvalStatus = "pending";
  }
  if (data.billing_volume && !data.billing_volume.approvalStatus) {
    data.billing_volume.approvalStatus = "pending";
  }
  if (data.standardized_billing && !data.standardized_billing.approvalStatus) {
    data.standardized_billing.approvalStatus = "pending";
  }

  return getDataFinal(data, production, configForm);
}

export function validationSchema() {
  return Yup.object({
    // production_volume: Yup.object({
    //   value: Yup.string().required('El campo "valor" es requerido'),
    // }),
    //creator_user: Yup.string().required(true),
    period: Yup.string("Dato requerido").required(
      'El campo "periodo" es obligatorio'
    ),
    production_volume: Yup.object({
          value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
          unit: Yup.string().when("value", {
            is: (val) => val !== 0 && val !== null && val !== "",
            then: (schema) => schema.required("Debe completar la unidad"),
            otherwise: (schema) => schema.notRequired(),
          }),
        }),

    billing_volume: Yup.object({
          value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
          unit: Yup.string().when("value", {
            is: (val) => val !== 0 && val !== null && val !== "",
            then: (schema) => schema.required("Debe completar la unidad"),
            otherwise: (schema) => schema.notRequired(),
          }),
        }),

    // unit: Yup.string().when(['production_volume.value', 'standardized_production.value', 'billing_volume.value', 'standardized_billing.value'], {
    //   is: (productionValue,standardizedValue, billingValue, standardizedBillingValue) => {
    //   console.log(productionValue,standardizedValue, billingValue, standardizedBillingValue)
    //     return (productionValue && productionValue.trim() !== '')||(standardizedValue && standardizedValue.trim() !== '') 
    //   || (billingValue && billingValue.trim() !== '')|| (standardizedBillingValue && standardizedBillingValue.trim() !== '')},
    //   then: Yup.string().required('El campo "unidad" es obligatorio cuando "valor" tiene datos cargados'),
    //   otherwise: Yup.string(),
    // }),
    //: Yup.object({
    //   value: Yup.string().required(),
    // }),
  });
}

function getDataFinal(dataFinal, form, configForm) {
  if (configForm && configForm.fields) {
    configForm.fields
      .filter(
        (field) =>
          (field.code.startsWith("VP") &&
            field.code !== "VPS" &&
            field.code !== "VP1") ||
          (field.code.startsWith("VF") &&
            field.code !== "VFS" &&
            field.code !== "VF1")
      )
      .map((result) => {
        let newField = form?.[result.name] || {
          code: result.code,
          unit: result.unit || "",
          value: "",
          standardized_coefficient: result.standardized_coefficient
            ? result.standardized_coefficient
            : 1,
          reviews: [],
          approvalStatus: "pending",
          files: [],
        };

        // Si el campo existe pero no tiene approvalStatus, agregarlo con valor por defecto
        if (newField && !newField.approvalStatus) {
          newField.approvalStatus = "pending";
        }

        // Agregar los nuevos campos al array
        dataFinal[result.name] = newField;
      });
  }
  return dataFinal;
}
